import React from "react";
import {Button, Loading} from "spectre-react/dist/cjs";


const ModalContainerLoading = ({close}) => {
    return (
        <div className="modal-container">
            <div className="modal-header">
                <span className="btn btn-clear float-right" onClick={close}/>
                <div className="modal-title h5">Загрузка...</div>
            </div>
            <div className="modal-body">
                <Loading large />
            </div>
            <div className="modal-footer">
                <Button link onClick={close}>Закрыть</Button>
            </div>
        </div>
    );
};

export default ModalContainerLoading;